'use client';
import React, { createContext, useContext, useState, useCallback, type ReactNode } from 'react';
import type { Centre } from '@/data/locations';

interface SelectedCentreContextValue {
  selectedCentre: Centre | null;
  setSelectedCentre: (centre: Centre | null) => void;
  clearCentre: () => void;
}

const SelectedCentreContext = createContext<SelectedCentreContextValue>({
  selectedCentre: null,
  setSelectedCentre: () => {},
  clearCentre: () => {},
});

export function SelectedCentreProvider({ children }: { children: ReactNode }) {
  const [selectedCentre, setSelectedCentreState] = useState<Centre | null>(null);

  const setSelectedCentre = useCallback((centre: Centre | null) => {
    setSelectedCentreState(centre);
  }, []);

  const clearCentre = useCallback(() => {
    setSelectedCentreState(null);
  }, []);

  return (
    <SelectedCentreContext.Provider value={{ selectedCentre, setSelectedCentre, clearCentre }}>
      {children}
    </SelectedCentreContext.Provider>
  );
}

export function useSelectedCentre() {
  return useContext(SelectedCentreContext);
}
